export function reorder<T>(list: T[], startIndex: number, endIndex: number) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}

// Update list with ordered list
// the ordered list is ordered by index
export function updateListOrder<T extends Partial<{ key: string }>>(overlayers: T[], ordered: T[]): T[] {
  return overlayers.map((layer) => {
    const zIndex = defineZIndex(ordered, layer);

    return {
      ...layer,
      zIndex,
    };
  });
}

export function defineZIndex<T extends Partial<{ key: string }>>(list: T[], layer: T): number {
  const index = list.map((o) => o.key).indexOf(layer.key);

  // if the layer is not inside the list, return -1
  if (index === -1) return -1;

  // else define zIndex
  const zIndex = list.length - 1 - index;
  return zIndex;
}
